import React from 'react';
import { Link } from "react-router-dom";
import '../styles/blog.css';
import blog2 from "../assets/images/blog 2.webp";
import blog3 from "../assets/images/blog 3.webp";
import blog4 from "../assets/images/blog4.webp";

const BlogPage = () => {
    return (
        <div>
            {/* Hero Section with Background Image */}
            <section className="blog">
                <div className="blog-overlay"></div>
                <div className="hero-content">
                    <h1>Blog</h1> {/* Updated h1 text */}
                    <p><Link to="/home">Home</Link> » <span>blog</span></p> {/* Updated breadcrumb */}
                </div>
            </section>

            {/* Blog Section */}
            <section className="blog-grid">
                <div className="blog-card">
                    <img src={blog2} alt="Penetration Testing" />
                    <div className="blog-card-body">
                        <h3>The Importance of Regular Penetration Testing</h3>
                        <Link to="/blog" className="read-more-btn">Read More »</Link>
                    </div>
                </div>

                <div className="blog-card">
                    <img src={blog3} alt="API Security" />
                    <div className="blog-card-body">
                        <h3>API Security Best Practices for Developers</h3>
                        <Link to="/blog" className="read-more-btn">Read More »</Link>
                    </div>
                </div>

                <div className="blog-card">
                    <img src={blog4} alt="Application Security" />
                    <div className="blog-card-body">
                        <h3>Understanding the Basics of Application Security</h3>
                        <Link to="/blog" className="read-more-btn">Read More »</Link>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default BlogPage;
